/* eslint-disable consistent-return */
import { Mongo } from 'meteor/mongo';
import SimpleSchema from 'simpl-schema';
import { isEmpty, map, cloneDeep, isEqual, assign } from 'lodash';

/**
 * A Configurations data base object schema.
 *
 * @typedef {object} ConfigurationsConnectors
 * @property {ConfigurationsProperties} connectionsFields - The date when it was created.
 * @property {string} owner - The owner id.
 * @property {string} updatedAt - The date when it was last updated.
 * @property {string} createdAt - The date when it was last updated.
 * @property {string} deleted - Indicates whether it is in the trash or not.
 * @property {string} name - The name.
 * @property {string} videoId - The video id.
 * @property {string} templateId - The template id.
 * @property {string} connectorId - The connector id.
 * @property {string} source - The source/table.
 * @property {string} isOnlyGeometry - Is show data.
 */

/**
 * A properties profile object schema.
 *
 * @typedef {object} ConfigurationsProperties
 * @property {string} nameField - The name of the column in table.
 * @property {string} value -The value to data base.
 * @property {string} isOrderElements -Is order de array elements to index.
 * @property {Array} elementIndex - Index element asociated to save value.
 * @property {string} elementAsociatedIndex - Index element asociated to other element (date/hour).
 */
let refSchema = {};
const validateDocument = document => {
  const cloneDocument = cloneDeep(document);
  const schema = !isEmpty(refSchema) ? refSchema.extend({ _id: String }) : {};
  const validationContext = !isEmpty(refSchema) ? schema.newContext('validatorSchema') : {};
  const fieldsError = {};
  let errors = [];

  if (!isEmpty(validationContext)) validationContext.validate(document);
  if (!validationContext.isValid()) errors = validationContext.validationErrors();

  map(errors, er => {
    if (!isEmpty(er) && isEqual(er.type, 'keyNotInSchema')) {
      assign(fieldsError, { [er.name]: 1 });
      delete cloneDocument[er.name];
    }
  });
  return cloneDocument;
};
const ConfigurationsConnectors = new Mongo.Collection('ConfigurationsConnectors', {
  transform: validateDocument
});

ConfigurationsConnectors.allow({
  insert: () => false,
  update: () => false,
  remove: () => false
});

ConfigurationsConnectors.deny({
  insert: () => true,
  update: () => true,
  remove: () => true
});

const connectionsFieldsProperties = new SimpleSchema({
  nameField: {
    type: String,
    label: 'The name of column in data base to save data'
  },
  value: {
    type: String,
    label: 'The value of element template to save in column of data base'
  },
  isOrderElements: {
    type: Boolean,
    label: 'The array is sort or not to index elements',
    optional: true
  },
  elementIndex: {
    type: Number,
    label: 'Index of element template asociated to value'
  },
  elementAsociatedIndex: {
    type: Number,
    label: 'Index to element asociated to other element (date/hour)'
  }
});

ConfigurationsConnectors.schema = new SimpleSchema({
  owner: {
    type: String,
    label: 'The ID of the user this video belongs to.'
  },
  createdAt: {
    type: String,
    label: 'The date this configuration was created in the database.',
    autoValue() {
      if (this.isInsert) return new Date().toISOString();
    }
  },
  updatedAt: {
    type: String,
    label: 'The date this configuration was last updated.',
    autoValue() {
      if (this.isInsert || this.isUpdate) return new Date().toISOString();
    }
  },
  deleted: {
    type: String,
    label: 'The date the profile was deleted',
    optional: true,
    autoValue() {
      if (this.isInsert) return 'no';
    }
  },
  name: {
    type: String,
    label: 'The name of congifuration register'
  },
  videoId: {
    type: String,
    label: 'The video id asociated to configuration'
  },
  templateId: {
    type: String,
    label: 'The id of template of video to configuration'
  },
  connectorId: {
    type: String,
    label: 'The connector asociated to configuration',
    optional: true
  },
  source: {
    type: String,
    label: 'The table/source/sourceId to configuration',
    optional: true
  },
  isOnlyGeometry: {
    type: Boolean,
    label: 'Is save only geometry fields'
  },
  connectionsFields: {
    type: Array,
    label: 'The array with connections between fields table and fields tamplate'
  },
  'connectionsFields.$': {
    type: connectionsFieldsProperties,
    label: 'The object with conenctions fields'
  }
});

refSchema = cloneDeep(ConfigurationsConnectors.schema);
ConfigurationsConnectors.attachSchema(ConfigurationsConnectors.schema);

export default ConfigurationsConnectors;
